const MEDIA_BASE = import.meta.env.VITE_MEDIA_BASE_URL || '/media';

/**
 * Resolve an image path to a full URL.
 * - Returns undefined for falsy values (compatible with img src)
 * - Passes through absolute URLs and paths starting with / (already resolved)
 * - Prepends the media base URL to relative S3 keys
 * - Handles signed URLs with query params (preserves ? without encoding)
 */
export const getImageUrl = (
  path: string | null | undefined,
): string | undefined => {
  if (!path) return undefined;
  if (
    path.startsWith('http://') ||
    path.startsWith('https://') ||
    path.startsWith('data:') ||
    path.startsWith('/')
  )
    return path;

  // For signed URLs with query params, split and reconstruct
  // to avoid the browser encoding ? as %3F in the path
  const qIndex = path.indexOf('?');

  if (qIndex !== -1) {
    const filePath = path.substring(0, qIndex);
    const queryString = path.substring(qIndex);
    return `${MEDIA_BASE}/${filePath}${queryString}`;
  }

  return `${MEDIA_BASE}/${path}`;
};
